import { createFileRoute } from '@tanstack/react-router';
import { DocumentsTopic } from '../screens/company/topics/DocumentsTopic';

export const Route = createFileRoute('/t/$tenant/settings/company/documents')({
  component: DocumentsTopic,
});
